import { render } from "./PublicationEvents.vue.js?vue&type=template&id=ac7c9a28!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationEvents.vue?vue&type=template&id=ac7c9a28"
import script from "./PublicationEvents.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationEvents.vue?vue&type=script&lang=js"
export * from "./PublicationEvents.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationEvents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac7c9a28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac7c9a28', __exports__)) {
    api.reload('ac7c9a28', __exports__)
  }
  
  module.hot.accept("./PublicationEvents.vue.js?vue&type=template&id=ac7c9a28!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationEvents.vue?vue&type=template&id=ac7c9a28", () => {
    api.rerender('ac7c9a28', render)
  })

}


export default __exports__